<div class="cell-renderer-index-name">
  <grid-ui-icon
    *ngIf="showInfoIcon"
    #indexInfoIcon
    (click)="clickInfoIcon()"
    data-hook="index-info-icon-span"
    class="cell-renderer-index-name__info-icon"
    name="info-circle"
    placement="top"
    [ngbTooltip]="'Show details'"
  ></grid-ui-icon>

  <span data-hook="cell-renderer-index-name">{{ indexName }}</span>

  <span class="mc-updated-badge" *ngIf="updatedQuarter"> Updated {{ updatedQuarter }} </span>
</div>
